// Carte des pharmacies Athana (section pharmacy-locator) : Google Maps + pharmacies.json, sans dépendance.
(() => {
  const root = document.querySelector('[data-phl]');
  if (!root) return;

  const STRINGS = {
    fr: {
      share: 'Partager', copied: 'Lien copié',
      placeholder: 'Ville, CP ou pharmacie', available: 'Disponible :', stock: 'sur place', h24: 'sous 24h',
      stockTag: 'Disponible sur place', h24Tag: 'Disponible sous 24h',
      stockLong: 'Essayable sur place', h24Long: 'Commande sous 24h',
      stockNote: 'Appelez avant de venir pour vérifier le stock.', h24Note: 'Réseau Evolupharm : retrait sous 24h, parlez-en à votre pharmacien.',
      callStock: 'Appeler pour vérifier le stock', call24h: 'Appeler pour commander', directions: 'Itinéraire',
      locate: 'Autour de moi', locating: 'Localisation en cours…', places: 'Lieux', pharmacies: 'Pharmacies',
      all: 'Voir toutes les pharmacies', close: 'Fermer', here: 'Vous êtes ici',
      closer: (n, d) => (n === 1 ? `1 pharmacie plus proche l'a sous 24h (${d}).` : `${n} pharmacies plus proches l'ont sous 24h (dès ${d}).`),
      show: 'Les afficher', empty: 'Aucune pharmacie dans cette zone. Dézoomez ou cherchez une ville.',
      more: (n) => `+ ${n} autres pharmacies dans cette zone : zoomez ou cherchez une ville pour les voir.`,
      geoDenied: 'La localisation est bloquée pour ce site. Autorisez-la dans votre navigateur (icône à gauche de l’adresse) ou cherchez une ville.',
      geoUnavailable: 'Position introuvable. Vérifiez que la localisation est activée sur votre appareil pour ce navigateur, ou cherchez une ville.',
      geoTimeout: 'La localisation a pris trop de temps. Réessayez ou cherchez une ville.',
      loadError: 'La carte n’a pas pu se charger. Rechargez la page dans un instant.', searchError: 'La recherche n’a pas abouti. Réessayez.',
    },
    en: {
      share: 'Share', copied: 'Link copied',
      placeholder: 'Town, postcode, pharmacy', available: 'Available:', stock: 'in store', h24: 'within 24h',
      stockTag: 'Available in store', h24Tag: 'Available within 24h',
      stockLong: 'Try it in store', h24Long: 'Order within 24h',
      stockNote: 'Call ahead to check stock.', h24Note: 'Evolupharm network: pick-up within 24h, ask your pharmacist.',
      callStock: 'Call to check stock', call24h: 'Call to order', directions: 'Directions',
      locate: 'Near me', locating: 'Finding your location…', places: 'Places', pharmacies: 'Pharmacies',
      all: 'Show all pharmacies', close: 'Close', here: 'You are here',
      closer: (n, d) => (n === 1 ? `1 closer pharmacy can get it within 24h (${d}).` : `${n} closer pharmacies can get it within 24h (from ${d}).`),
      show: 'Show them', empty: 'No pharmacy in this area. Zoom out or search for a town.',
      more: (n) => `+ ${n} more pharmacies in this area: zoom in or search for a town to see them.`,
      geoDenied: 'Location is blocked for this site. Allow it in your browser (icon left of the address bar) or search for a town.',
      geoUnavailable: 'Your position could not be found. Check that location is enabled on your device for this browser, or search for a town.',
      geoTimeout: 'Finding your location took too long. Try again or search for a town.',
      loadError: 'The map could not load. Please reload the page in a moment.', searchError: 'The search failed. Please try again.',
    },
    de: {
      share: 'Teilen', copied: 'Link kopiert',
      placeholder: 'Ort, PLZ, Apotheke', available: 'Verfügbar:', stock: 'vor Ort', h24: 'in 24 Std.',
      stockTag: 'Vor Ort verfügbar', h24Tag: 'In 24 Std. verfügbar',
      stockLong: 'Vor Ort testen', h24Long: 'Bestellung in 24 Std.',
      stockNote: 'Rufen Sie vorher an, um den Vorrat zu prüfen.', h24Note: 'Evolupharm-Netzwerk: Abholung in 24 Std., fragen Sie Ihre Apotheke.',
      callStock: 'Anrufen und Vorrat prüfen', call24h: 'Anrufen und bestellen', directions: 'Route',
      locate: 'In meiner Nähe', locating: 'Standort wird ermittelt…', places: 'Orte', pharmacies: 'Apotheken',
      all: 'Alle Apotheken anzeigen', close: 'Schließen', here: 'Sie sind hier',
      closer: (n, d) => (n === 1 ? `1 nähere Apotheke hat es in 24 Std. (${d}).` : `${n} nähere Apotheken haben es in 24 Std. (ab ${d}).`),
      show: 'Anzeigen', empty: 'Keine Apotheke in diesem Bereich. Herauszoomen oder nach einem Ort suchen.',
      more: (n) => `+ ${n} weitere Apotheken in diesem Bereich: hineinzoomen oder nach einem Ort suchen.`,
      geoDenied: 'Die Standortfreigabe ist für diese Seite blockiert. Erlauben Sie sie im Browser (Symbol links neben der Adresse) oder suchen Sie nach einem Ort.',
      geoUnavailable: 'Ihr Standort wurde nicht gefunden. Prüfen Sie, ob die Ortung auf Ihrem Gerät für diesen Browser aktiviert ist, oder suchen Sie nach einem Ort.',
      geoTimeout: 'Die Standortermittlung hat zu lange gedauert. Versuchen Sie es erneut oder suchen Sie nach einem Ort.',
      loadError: 'Die Karte konnte nicht geladen werden. Bitte laden Sie die Seite gleich neu.', searchError: 'Die Suche ist fehlgeschlagen. Bitte erneut versuchen.',
    },
    it: {
      share: 'Condividi', copied: 'Link copiato',
      placeholder: 'Città, CAP o farmacia', available: 'Disponibile:', stock: 'in farmacia', h24: 'entro 24h',
      stockTag: 'Disponibile in farmacia', h24Tag: 'Disponibile entro 24h',
      stockLong: 'Da provare in farmacia', h24Long: 'Su ordine entro 24h',
      stockNote: 'Chiama prima di andare per verificare la disponibilità.', h24Note: 'Rete Evolupharm: ritiro entro 24h, chiedi al tuo farmacista.',
      callStock: 'Chiama per verificare', call24h: 'Chiama per ordinare', directions: 'Indicazioni',
      locate: 'Vicino a me', locating: 'Localizzazione in corso…', places: 'Luoghi', pharmacies: 'Farmacie',
      all: 'Mostra tutte le farmacie', close: 'Chiudi', here: 'Sei qui',
      closer: (n, d) => (n === 1 ? `1 farmacia più vicina lo ha entro 24h (${d}).` : `${n} farmacie più vicine lo hanno entro 24h (da ${d}).`),
      show: 'Mostrale', empty: 'Nessuna farmacia in questa zona. Riduci lo zoom o cerca una città.',
      more: (n) => `+ altre ${n} farmacie in questa zona: ingrandisci o cerca una città per vederle.`,
      geoDenied: 'La localizzazione è bloccata per questo sito. Consentila nel browser (icona a sinistra dell’indirizzo) o cerca una città.',
      geoUnavailable: 'Posizione non trovata. Verifica che la localizzazione sia attiva sul dispositivo per questo browser, oppure cerca una città.',
      geoTimeout: 'La localizzazione ha richiesto troppo tempo. Riprova o cerca una città.',
      loadError: 'Impossibile caricare la mappa. Ricarica la pagina tra un istante.', searchError: 'La ricerca non è riuscita. Riprova.',
    },
    es: {
      share: 'Compartir', copied: 'Enlace copiado',
      placeholder: 'Ciudad, CP o farmacia', available: 'Disponible:', stock: 'en farmacia', h24: 'en 24 h',
      stockTag: 'Disponible en farmacia', h24Tag: 'Disponible en 24 h',
      stockLong: 'Pruébalo en la farmacia', h24Long: 'Por encargo en 24 h',
      stockNote: 'Llama antes de ir para comprobar el stock.', h24Note: 'Red Evolupharm: recogida en 24 h, consulta a tu farmacéutico.',
      callStock: 'Llamar para comprobar', call24h: 'Llamar para encargar', directions: 'Cómo llegar',
      locate: 'Cerca de mí', locating: 'Buscando tu ubicación…', places: 'Lugares', pharmacies: 'Farmacias',
      all: 'Ver todas las farmacias', close: 'Cerrar', here: 'Estás aquí',
      closer: (n, d) => (n === 1 ? `1 farmacia más cercana lo tiene en 24 h (${d}).` : `${n} farmacias más cercanas lo tienen en 24 h (desde ${d}).`),
      show: 'Mostrarlas', empty: 'No hay farmacias en esta zona. Aleja el zoom o busca una ciudad.',
      more: (n) => `+ ${n} farmacias más en esta zona: acerca el zoom o busca una ciudad para verlas.`,
      geoDenied: 'La ubicación está bloqueada para este sitio. Permítela en tu navegador (icono a la izquierda de la dirección) o busca una ciudad.',
      geoUnavailable: 'No se ha encontrado tu ubicación. Comprueba que la ubicación esté activada en tu dispositivo para este navegador, o busca una ciudad.',
      geoTimeout: 'La localización ha tardado demasiado. Inténtalo de nuevo o busca una ciudad.',
      loadError: 'No se ha podido cargar el mapa. Recarga la página en un momento.', searchError: 'La búsqueda no ha funcionado. Inténtalo de nuevo.',
    },
    nl: {
      share: 'Delen', copied: 'Link gekopieerd',
      placeholder: 'Plaats, postcode of apotheek', available: 'Beschikbaar:', stock: 'ter plaatse', h24: 'binnen 24 uur',
      stockTag: 'Ter plaatse beschikbaar', h24Tag: 'Binnen 24 uur beschikbaar',
      stockLong: 'Ter plaatse uit te proberen', h24Long: 'Binnen 24 uur te bestellen',
      stockNote: 'Bel vooraf om de voorraad te controleren.', h24Note: 'Evolupharm-netwerk: afhalen binnen 24 uur, vraag het uw apotheker.',
      callStock: 'Bellen om de voorraad te controleren', call24h: 'Bellen om te bestellen', directions: 'Route',
      locate: 'In mijn buurt', locating: 'Locatie wordt bepaald…', places: 'Plaatsen', pharmacies: 'Apotheken',
      all: 'Alle apotheken tonen', close: 'Sluiten', here: 'U bent hier',
      closer: (n, d) => (n === 1 ? `1 dichterbij gelegen apotheek kan het binnen 24 uur leveren (${d}).` : `${n} dichterbij gelegen apotheken kunnen het binnen 24 uur leveren (vanaf ${d}).`),
      show: 'Tonen', empty: 'Geen apotheek in dit gebied. Zoom uit of zoek een plaats.',
      more: (n) => `+ ${n} andere apotheken in dit gebied: zoom in of zoek een plaats om ze te zien.`,
      geoDenied: 'Locatie is geblokkeerd voor deze site. Sta het toe in uw browser (icoon links van het adres) of zoek een plaats.',
      geoUnavailable: 'Uw positie kon niet worden gevonden. Controleer of locatie is ingeschakeld op uw apparaat voor deze browser, of zoek een plaats.',
      geoTimeout: 'Het bepalen van uw locatie duurde te lang. Probeer het opnieuw of zoek een plaats.',
      loadError: 'De kaart kon niet worden geladen. Herlaad de pagina over een moment.', searchError: 'Het zoeken is mislukt. Probeer het opnieuw.',
    },
    pt: {
      share: 'Partilhar', copied: 'Ligação copiada',
      placeholder: 'Cidade, código postal ou farmácia', available: 'Disponível:', stock: 'no local', h24: 'em 24 h',
      stockTag: 'Disponível no local', h24Tag: 'Disponível em 24 h',
      stockLong: 'Experimente no local', h24Long: 'Encomenda em 24 h',
      stockNote: 'Ligue antes de ir para confirmar o stock.', h24Note: 'Rede Evolupharm: levantamento em 24 h, fale com o seu farmacêutico.',
      callStock: 'Ligar para confirmar o stock', call24h: 'Ligar para encomendar', directions: 'Itinerário',
      locate: 'Perto de mim', locating: 'A obter a sua localização…', places: 'Locais', pharmacies: 'Farmácias',
      all: 'Ver todas as farmácias', close: 'Fechar', here: 'Está aqui',
      closer: (n, d) => (n === 1 ? `1 farmácia mais próxima tem-no em 24 h (${d}).` : `${n} farmácias mais próximas têm-no em 24 h (a partir de ${d}).`),
      show: 'Mostrar', empty: 'Nenhuma farmácia nesta zona. Afaste o zoom ou pesquise uma cidade.',
      more: (n) => `+ ${n} outras farmácias nesta zona: aproxime o zoom ou pesquise uma cidade para as ver.`,
      geoDenied: 'A localização está bloqueada para este site. Autorize-a no seu navegador (ícone à esquerda do endereço) ou pesquise uma cidade.',
      geoUnavailable: 'Não foi possível encontrar a sua posição. Verifique se a localização está ativada no seu dispositivo para este navegador, ou pesquise uma cidade.',
      geoTimeout: 'A localização demorou demasiado. Tente novamente ou pesquise uma cidade.',
      loadError: 'Não foi possível carregar o mapa. Recarregue a página dentro de momentos.', searchError: 'A pesquisa falhou. Tente novamente.',
    },
  };

  // Shopify met la langue de la page dans <html lang> (sous-dossiers /en/, /de/…).
  const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const T = STRINGS[lang] || STRINGS.fr;

  // Vue de départ identique à l'ancien locator (zoom 6) ; zoom 5 sur mobile pour voir toute la métropole.
  const METRO = { center: { lat: 46.9, lng: 2.55 }, zoom: 6 };
  // Suggestions de lieux : partout (Europe, DOM-TOM), avec la France métropolitaine en priorité.
  const PRIORITE_FRANCE = { north: 51.2, south: 41.3, east: 9.6, west: -5.2 };
  const ZOOM_FICHE = 15;
  const ZOOM_RECHERCHE = { min: 7, max: 12 };
  // À partir de l'échelle d'une ville, les « sous 24h » passent de points discrets à des pins.
  const ZOOM_PINS_24H = 11;
  const LISTE_MAX = 50;
  // En ville une pharmacie « sur place » à 2 km suffit : on ne signale les « sous 24h » masquées que si elle est plus loin.
  const SEUIL_SOUS_24H_KM = 5;

  const $ = (s) => root.querySelector(s);
  const input = $('.phl-search__input');
  const suggest = $('.phl-suggest');
  const status = $('.phl-status');
  const listEl = $('.phl-list');
  const mapEl = $('.phl-map');
  const sheet = $('.phl-sheet');
  const locateBtn = $('.phl-locate');
  const chips = root.querySelectorAll('.phl-chip');

  const shown = { stock: true, h24: true };
  let map, info, Marker, selected, origin, originMarker, villeUrl;
  let pharmacies = [];

  const group = (p) => (p.stock ? 'stock' : 'h24');
  const visible = (p) => shown[group(p)];
  const norm = (s) => s.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
  // Pays affiché seulement hors de France (p.cc, voir tools/pharmacies_json.py), dans la langue du site.
  const regions = Intl.DisplayNames ? new Intl.DisplayNames([lang], { type: 'region' }) : null;
  const localite = (p) => `${p.cp} ${p.city}${p.cc ? `, ${regions?.of(p.cc) ?? p.cc}` : ''}`;
  const fmt1 = new Intl.NumberFormat(lang, { maximumFractionDigits: 1 });
  const fmtKm = (d) => `${d < 10 ? fmt1.format(d) : Math.round(d)} km`;
  const tel = (p) => `tel:${p.tel.replace(/[^\d+]/g, '')}`;

  // Statistiques anonymes vers le Google Sheet de la section : ni cookie, ni identifiant, ni position précise.
  const appareil = matchMedia('(pointer: coarse)').matches ? 'mobile' : 'ordinateur';
  function track(evenement, p, extra) {
    if (!root.dataset.stats) return;
    const d = { evenement, langue: lang, appareil, ...(p && { pharmacie: p.name, cp: p.cp, ville: p.city, groupe: p.stock ? 'sur place' : 'sous 24h' }), ...extra };
    if (d.cp) d.cp = `'${d.cp}`; // apostrophe = texte pour Google Sheets, sinon « 06460 » devient 6460
    navigator.sendBeacon(root.dataset.stats, JSON.stringify(d));
  }

  // L'adresse de la page reflète la recherche ou la pharmacie ouverte : on la copie pour la partager.
  function lienPage(cle, valeur) {
    const u = new URL(location.href);
    u.searchParams.delete('ville');
    u.searchParams.delete('pharmacie');
    if (cle) u.searchParams.set(cle, valeur);
    return u.href;
  }
  const setUrl = (cle, valeur) => history.replaceState(history.state, '', lienPage(cle, valeur));

  function dist(a, b) {
    const r = Math.PI / 180;
    const h = Math.sin(((b.lat - a.lat) * r) / 2) ** 2
      + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(((b.lng - a.lng) * r) / 2) ** 2;
    return 12742 * Math.asin(Math.sqrt(h));
  }

  function say(msg, label, action) {
    status.replaceChildren(msg);
    if (!label) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'phl-status__action';
    b.textContent = label;
    b.addEventListener('click', action);
    status.append(' ', b);
  }

  // Textes statiques (le titre est traduit dans la section, sans attendre ce script).
  input.placeholder = T.placeholder;
  input.setAttribute('aria-label', T.placeholder);
  $('.phl-filters__label').textContent = T.available;
  chips.forEach((c) => { c.innerHTML = `<span class="phl-dot phl-dot--${c.dataset.group}"></span>${T[c.dataset.group]}`; });
  locateBtn.setAttribute('aria-label', T.locate);
  locateBtn.title = T.locate;

  // Chargements en parallèle : données (préchargées par la section) et Google Maps (lancé par la section).
  const dataP = fetch(root.dataset.src).then((r) => {
    if (!r.ok) throw new Error(`pharmacies.json ${r.status}`);
    return r.json();
  });
  const mapsP = window.phlMaps;
  window.gm_authFailure = () => say(T.loadError);
  Promise.all([dataP, mapsP]).then(([data]) => init(data)).catch((e) => {
    console.error('[pharmacy-locator]', e);
    say(T.loadError);
  });

  async function init(data) {
    const [{ Map, InfoWindow, OverlayView }, { AdvancedMarkerElement }] = await Promise.all([
      google.maps.importLibrary('maps'), google.maps.importLibrary('marker'),
    ]);
    Marker = AdvancedMarkerElement;
    pharmacies = data;
    pharmacies.forEach((p, i) => { p.i = i; p.key = norm(`${p.name} ${p.city} ${p.cp}`); p.ll = new google.maps.LatLng(p.lat, p.lng); });

    map = new Map(mapEl, {
      mapId: root.dataset.mapId,
      center: METRO.center,
      zoom: mapEl.clientWidth < 600 ? METRO.zoom - 1 : METRO.zoom,
      disableDefaultUI: true,
      zoomControl: true,
      // Au milieu du bord droit, à l'écart des boutons fixes du bas de l'écran.
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
      fullscreenControl: true,
      clickableIcons: false,
    });
    // Hors d'Europe (DOM, étranger) : vue d'ensemble, la personne choisit son territoire.
    if (!Intl.DateTimeFormat().resolvedOptions().timeZone?.startsWith('Europe/')) fitAll();

    const allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'phl-mapbtn';
    allBtn.title = T.all;
    allBtn.setAttribute('aria-label', T.all);
    allBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>';
    allBtn.addEventListener('click', fitAll);
    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(allBtn);

    info = new InfoWindow({ headerDisabled: true, maxWidth: 330 });
    points = creerPoints(OverlayView);
    points.setMap(map);
    // Un clic sur un point « sous 24h » dessiné ouvre sa fiche ; ailleurs, il ferme la fiche ouverte.
    map.addListener('click', (e) => {
      const pt = points.getProjection()?.fromLatLngToContainerPixel(e.latLng);
      const touche = pt && points.affiches.find(([x, y]) => (x - pt.x) ** 2 + (y - pt.y) ** 2 < 100);
      if (touche) select(touche[2], false, 'carte');
      else closeCard();
    });
    map.addListener('idle', () => { syncMarkers(); renderList(); });
    map.addListener('zoom_changed', () => root.classList.toggle('phl--proche', map.getZoom() >= ZOOM_PINS_24H));

    // Les « sur place » d'abord ; les autres arrivent par paquets au premier « idle » (syncMarkers).
    pharmacies.filter((p) => p.stock).forEach((p) => { markerFor(p).map = map; });
    track('vue');
    ouvrirDepuisLien();
  }

  // Liens partageables : ?pharmacie=<slug> (voir tools/pharmacies_json.py) ou ?ville=<ville ou CP>.
  async function ouvrirDepuisLien() {
    const q = new URLSearchParams(location.search);
    const slug = q.get('pharmacie');
    const p = slug && pharmacies.find((x) => x.slug === slug);
    if (p) {
      input.value = p.name;
      select(p, true, 'lien');
      return;
    }
    // Pharmacie renommée ou retirée : on retombe sur son code postal.
    const ville = q.get('ville') || slug?.match(/\d{4,5}$/)?.[0];
    if (!ville) return;
    const [pp] = await fetchLieux(ville).catch(() => []);
    if (pp) choose({ pp, label: ville }, 'lien');
  }

  function fitAll() {
    const b = new google.maps.LatLngBounds();
    pharmacies.forEach((p) => b.extend(p));
    map.fitBounds(b, 56);
  }

  // Marqueurs : créés à la première apparition, puis seulement attachés ou détachés de la carte.
  function markerFor(p) {
    if (!p.marker) {
      const el = document.createElement('div');
      el.className = `phl-pin phl-pin--${group(p)}`;
      p.marker = new Marker({ position: { lat: p.lat, lng: p.lng }, content: el, title: p.name, zIndex: p.stock ? 2 : 1, gmpClickable: true });
      p.marker.addEventListener('gmp-click', () => select(p, false, 'carte'));
    }
    return p.marker;
  }

  // Zone affichée élargie de moitié de chaque côté : les pins y sont prêts quand on fait glisser la carte.
  function zone(b) {
    if (!b) return null;
    const ne = b.getNorthEast();
    const sw = b.getSouthWest();
    if (sw.lng() > ne.lng()) return null; // carte à cheval sur l'antiméridien : pas de tri
    const dLat = (ne.lat() - sw.lat()) / 2;
    const dLng = (ne.lng() - sw.lng()) / 2;
    return { n: ne.lat() + dLat, s: sw.lat() - dLat, e: ne.lng() + dLng, w: sw.lng() - dLng };
  }
  const dans = (p, z) => !z || (p.lat <= z.n && p.lat >= z.s && p.lng <= z.e && p.lng >= z.w);

  // Vue large : les « sous 24h » sont dessinés sur un seul canvas. Un millier de marqueurs DOM gelaient
  // le mobile plusieurs secondes à chaque zoom ; leurs pins DOM ne servent qu'en vue rapprochée.
  let points;
  const proche = () => map.getZoom() >= ZOOM_PINS_24H;
  function creerPoints(OverlayView) {
    const c = document.createElement('canvas');
    c.className = 'phl-points';
    const o = new OverlayView();
    o.affiches = [];
    o.onAdd = () => o.getPanes().overlayLayer.append(c);
    o.onRemove = () => c.remove();
    o.draw = () => {
      const proj = o.getProjection();
      if (!proj) return;
      const w = mapEl.clientWidth;
      const h = mapEl.clientHeight;
      const dpr = devicePixelRatio || 1;
      const coin = proj.fromLatLngToDivPixel(proj.fromContainerPixelToLatLng(new google.maps.Point(0, 0)));
      Object.assign(c.style, { left: `${coin.x}px`, top: `${coin.y}px`, width: `${w}px`, height: `${h}px` });
      if (c.width !== w * dpr) c.width = w * dpr;
      if (c.height !== h * dpr) c.height = h * dpr;
      const ctx = c.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      o.affiches = [];
      if (proche() || !shown.h24) return;
      ctx.fillStyle = root.dataset.stock === 'false' ? 'rgba(2, 21, 83, .85)' : 'rgba(2, 21, 83, .4)';
      ctx.strokeStyle = 'rgba(255, 255, 255, .9)';
      for (const p of pharmacies) {
        if (p.stock || p === selected) continue;
        const pt = proj.fromLatLngToContainerPixel(p.ll);
        if (pt.x < -6 || pt.y < -6 || pt.x > w + 6 || pt.y > h + 6) continue;
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
        o.affiches.push([pt.x, pt.y, p]);
      }
    };
    return o;
  }

  // Seuls les pins utiles sont posés : ceux de la zone, et les « sous 24h » seulement en vue rapprochée.
  // Les pins à ajouter le sont par paquets pour garder la page réactive.
  let synchro = 0;
  function syncMarkers(z = zone(map?.getBounds())) {
    root.dataset.stock = shown.stock;
    if (selected && !visible(selected)) closeCard();
    const pins24 = map && proche();
    const id = ++synchro;
    const aPoser = [];
    for (const p of pharmacies) {
      if (p === selected || (visible(p) && (p.stock || pins24) && dans(p, z))) { if (!p.marker?.map) aPoser.push(p); }
      else if (p.marker?.map) p.marker.map = null;
    }
    points?.draw();
    (function paquet() {
      if (id !== synchro) return; // une synchro plus récente a pris le relais
      aPoser.splice(0, 150).forEach((p) => { markerFor(p).map = map; });
      if (aPoser.length) setTimeout(paquet);
    })();
  }

  function setFilters(changes) {
    Object.assign(shown, changes);
    chips.forEach((c) => c.setAttribute('aria-pressed', shown[c.dataset.group]));
    syncMarkers();
    renderList();
    hint();
  }
  chips.forEach((c) => c.addEventListener('click', () => {
    const g = c.dataset.group;
    setFilters({ [g]: !shown[g] });
    track('filtre', null, { detail: `${g === 'stock' ? 'sur place' : 'sous 24h'} ${shown[g] ? 'affichées' : 'masquées'}` });
  }));

  function setSelected(p) {
    selected?.marker?.content.classList.remove('is-active');
    selected = p;
    p?.marker.content.classList.add('is-active');
    points?.draw(); // le point sélectionné est remplacé par son pin
  }

  function closeCard() {
    info?.close();
    sheet.hidden = true;
    if (selected) setUrl(villeUrl && 'ville', villeUrl);
    setSelected(null);
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && selected) closeCard(); });

  function resetOrigin() {
    origin = null;
    villeUrl = null;
    if (originMarker) originMarker.map = null;
    setUrl(null);
    say('');
    renderList();
  }

  function select(p, zoom, source) {
    track('fiche', p, { detail: source });
    if (!visible(p)) setFilters({ [group(p)]: true });
    const m = markerFor(p);
    m.map = map; // lien ouvert avant la fin de la création des marqueurs
    setSelected(p);
    setUrl('pharmacie', p.slug);
    // Petite carte (mobile) : fiche en bas de la carte, la bulle Google y serait trop étroite.
    const enBas = mapEl.clientWidth < 500;
    if (enBas) {
      info.close();
      sheet.replaceChildren(card(p));
      sheet.hidden = false;
    } else {
      sheet.hidden = true;
    }
    // Fiche en bas : le centre descend d'une demi-fiche pour que le pin reste visible au-dessus.
    // Calculé plutôt que panBy, ignoré par Google quand la carte n'est pas encore prête (lien partagé).
    const z = zoom ? Math.max(map.getZoom(), ZOOM_FICHE) : map.getZoom();
    const decalage = enBas ? (sheet.offsetHeight / 2) * (360 / (256 * 2 ** z)) * Math.cos((p.lat * Math.PI) / 180) : 0;
    const centre = { lat: p.lat - decalage, lng: p.lng };
    if (zoom) {
      // Pins du quartier posés avant le zoom ; le reste de la zone suit au « idle ».
      syncMarkers(zone(new google.maps.LatLngBounds({ lat: p.lat - 0.02, lng: p.lng - 0.03 }, { lat: p.lat + 0.02, lng: p.lng + 0.03 })));
      map.moveCamera({ center: centre, zoom: z });
    } else if (enBas) {
      map.panTo(centre);
    }
    if (!enBas) {
      info.setContent(card(p));
      info.open({ map, anchor: m });
    }
  }


  // Fiche : sur ordinateur le numéro et une consigne, sur téléphone un bouton d'appel (voir le CSS).
  function card(p) {
    const el = document.createElement('div');
    el.className = 'phl-card';
    const dest = encodeURIComponent(`${p.name}, ${p.addr}, ${localite(p)}`);
    el.innerHTML = `
      <button type="button" class="phl-card__close" aria-label="${T.close}"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <p class="phl-badge phl-badge--${group(p)}"><span class="phl-dot phl-dot--${group(p)}"></span>${p.stock ? T.stockLong : T.h24Long}</p>
      <p class="phl-card__name">${esc(p.name)}</p>
      <p class="phl-card__addr">${esc(p.addr)}${p.addr2 ? `<br>${esc(p.addr2)}` : ''}<br>${esc(localite(p))}${origin ? ` · ${fmtKm(dist(origin, p))}` : ''}</p>
      <p class="phl-card__tel"><a href="${tel(p)}">${esc(p.tel)}</a></p>
      <p class="phl-card__note phl-card__note--${group(p)}">${p.stock ? T.stockNote : T.h24Note}</p>
      ${p.email ? `<p class="phl-card__mail"><a href="mailto:${esc(p.email)}">${esc(p.email)}</a></p>` : ''}
      <div class="phl-card__actions">
        <a class="phl-btn phl-btn--primary phl-card__call" href="${tel(p)}">${p.stock ? T.callStock : T.call24h}</a>
        <a class="phl-btn phl-card__route" href="https://www.google.com/maps/dir/?api=1&destination=${dest}" target="_blank" rel="noopener">${T.directions}</a>
      </div>
      <button type="button" class="phl-card__share"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/></svg><span>${T.share}</span></button>`;
    el.querySelector('.phl-card__close').addEventListener('click', closeCard);
    el.querySelectorAll('a[href^="tel:"]').forEach((a) => a.addEventListener('click', () => track('appel', p)));
    el.querySelector('.phl-card__route').addEventListener('click', () => track('itineraire', p));
    el.querySelector('.phl-card__share').addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const url = lienPage('pharmacie', p.slug);
      track('partage', p);
      if (navigator.share && appareil === 'mobile') return navigator.share({ title: p.name, url }).catch(() => {});
      try {
        await navigator.clipboard.writeText(url);
        btn.querySelector('span').textContent = T.copied;
      } catch {
        prompt(T.share, url); // copie refusée par le navigateur : on montre le lien
      }
    });
    return el;
  }

  // Liste : pharmacies affichées dans la zone visible, triées par distance (au point cherché, sinon au centre).
  function renderList() {
    const b = map?.getBounds();
    if (!b) return;
    const ref = origin ?? map.getCenter().toJSON();
    const items = pharmacies.filter((p) => visible(p) && b.contains(p));
    for (const p of items) p.d = dist(ref, p);
    items.sort((a, c) => a.d - c.d);
    listEl.replaceChildren(...items.slice(0, LISTE_MAX).map((p) => {
      const li = document.createElement('li');
      li.innerHTML = `<button type="button" class="phl-item" data-i="${p.i}">
        <span class="phl-dot phl-dot--${group(p)}"></span>
        <span class="phl-item__body"><span class="phl-item__name">${esc(p.name)}</span><span class="phl-item__addr">${esc(p.addr)}, ${esc(localite(p))}</span><span class="phl-item__tag phl-item__tag--${group(p)}">${p.stock ? T.stockTag : T.h24Tag}</span></span>
        ${origin ? `<span class="phl-item__dist">${fmtKm(p.d)}</span>` : ''}</button>`;
      return li;
    }));
    const note = !items.length ? T.empty : items.length > LISTE_MAX ? T.more(items.length - LISTE_MAX) : '';
    if (note) listEl.append(Object.assign(document.createElement('li'), { className: 'phl-list__note', textContent: note }));
  }

  listEl.addEventListener('click', (e) => {
    const btn = e.target.closest('.phl-item');
    if (!btn) return;
    select(pharmacies[btn.dataset.i], true, 'liste');
    const r = mapEl.getBoundingClientRect();
    if (r.top < 0 || r.bottom > innerHeight) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function nearest(o, n) {
    return pharmacies.filter(visible).map((p) => [dist(o, p), p]).sort((a, b) => a[0] - b[0]).slice(0, n).map(([, p]) => p);
  }

  // Après une recherche de lieu ou « Autour de moi » : cadre le point et ses 3 plus proches, zoom borné.
  // Lieu cherché étendu (île, région, pays) : son emprise Google est ajoutée et le zoom minimum levé,
  // pour voir tout le lieu (La Réunion, la Guadeloupe…) et pas seulement les pharmacies d'une ville.
  function frame(emprise) {
    const b = new google.maps.LatLngBounds();
    [origin, ...nearest(origin, 3)].forEach((p) => b.extend(p));
    if (emprise) b.union(emprise);
    syncMarkers(zone(b)); // avant le zoom, voir syncMarkers
    map.fitBounds(b, 48);
    google.maps.event.addListenerOnce(map, 'idle', () => {
      const z = Math.min(Math.max(map.getZoom(), emprise ? 0 : ZOOM_RECHERCHE.min), ZOOM_RECHERCHE.max);
      if (z !== map.getZoom()) map.setZoom(z);
    });
  }

  // Seulement si la personne a masqué les « sous 24h » et qu'une « sur place » n'est pas tout près.
  function hint() {
    if (!origin || !shown.stock || shown.h24) return say('');
    const dStock = Math.min(...pharmacies.filter((p) => p.stock).map((p) => dist(origin, p)));
    const closer = pharmacies.filter((p) => !p.stock).map((p) => dist(origin, p)).filter((d) => d < dStock);
    if (dStock < SEUIL_SOUS_24H_KM || !closer.length) return say('');
    say(T.closer(closer.length, fmtKm(Math.min(...closer))), T.show, () => { setFilters({ h24: true }); frame(); });
  }

  function goTo(o, here, emprise) {
    origin = o;
    if (!originMarker) originMarker = new Marker({ content: document.createElement('div'), zIndex: 5 });
    originMarker.content.className = here ? 'phl-origin phl-origin--here' : 'phl-origin';
    originMarker.title = here ? T.here : '';
    originMarker.position = o;
    originMarker.map = map;
    closeCard();
    frame(emprise);
    hint();
  }

  // « Autour de moi » : précision normale (suffisante ici, et bien plus rapide), chaque échec est expliqué.
  locateBtn.addEventListener('click', () => {
    if (!navigator.geolocation || !map) return say(T.geoUnavailable);
    locateBtn.setAttribute('aria-busy', 'true');
    say(T.locating);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        locateBtn.removeAttribute('aria-busy');
        say('');
        villeUrl = null;
        setUrl(null);
        goTo({ lat: pos.coords.latitude, lng: pos.coords.longitude }, true);
        // Statistique : seulement le département de la pharmacie la plus proche, pas la position.
        const n = nearest(origin, 1)[0]; // hors de France, le pays (CH…) : 8001 donnerait le « 80 » de la Somme
        track('position', null, { detail: 'ok', cp: n && (n.cc || n.cp.slice(0, 2)) });
      },
      (err) => {
        locateBtn.removeAttribute('aria-busy');
        say(err.code === err.PERMISSION_DENIED ? T.geoDenied : err.code === err.TIMEOUT ? T.geoTimeout : T.geoUnavailable);
        track('position', null, { detail: err.code === err.PERMISSION_DENIED ? 'refusée' : err.code === err.TIMEOUT ? 'trop longue' : 'introuvable' });
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
    );
  });

  // Recherche : un champ, deux groupes de suggestions (lieux Google, pharmacies en local).
  let options = [];
  let active = -1;
  let lieux = [];
  let lieuxFor = '';
  let timer;
  let token;
  let placesLib;

  function matchPharmacies(q) {
    const words = norm(q).split(/[\s,.'’-]+/).filter((w) => w && !w.startsWith('pharma'));
    if (!words.length) return [];
    return pharmacies
      .filter((p) => words.every((w) => p.key.includes(w)))
      .sort((a, b) => b.stock - a.stock || a.name.localeCompare(b.name))
      .slice(0, 5);
  }

  async function fetchLieux(q) {
    placesLib ??= mapsP.then(() => google.maps.importLibrary('places'));
    const { AutocompleteSuggestion, AutocompleteSessionToken } = await placesLib;
    token ??= new AutocompleteSessionToken();
    const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input: q, sessionToken: token, language: lang, region: 'fr', locationBias: PRIORITE_FRANCE,
    });
    return suggestions.map((s) => s.placePrediction).filter(Boolean).slice(0, 4);
  }

  async function loadLieux(q) {
    if (q === lieuxFor) return;
    const res = await fetchLieux(q).catch((e) => { console.warn('[pharmacy-locator]', e); return []; });
    if (input.value.trim() === q) { lieux = res; lieuxFor = q; }
  }

  function closeSuggest() {
    suggest.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  }

  function renderSuggest() {
    const q = input.value.trim();
    const groups = [
      [T.places, lieux.map((pp) => ({ pp, label: pp.mainText?.text ?? pp.text.text, sub: pp.secondaryText?.text ?? '' }))],
      [T.pharmacies, (q ? matchPharmacies(q) : []).map((p) => ({ p, label: p.name, sub: localite(p) }))],
    ];
    if (norm(q).includes('pharma')) groups.reverse();
    options = [];
    suggest.replaceChildren();
    for (const [title, opts] of groups) {
      if (!opts.length) continue;
      suggest.append(Object.assign(document.createElement('li'), { className: 'phl-suggest__group', role: 'presentation', textContent: title }));
      for (const o of opts) {
        const li = document.createElement('li');
        li.id = `phl-opt-${options.length}`;
        li.className = 'phl-suggest__opt';
        li.setAttribute('role', 'option');
        li.innerHTML = `<span class="phl-dot phl-dot--${o.p ? group(o.p) : 'lieu'}"></span><span><span class="phl-suggest__label">${esc(o.label)}</span> <span class="phl-suggest__sub">${esc(o.sub)}</span></span>`;
        li.addEventListener('mousedown', (e) => e.preventDefault()); // garde le focus dans le champ
        li.addEventListener('click', () => choose(o));
        options.push(o);
        suggest.append(li);
      }
    }
    if (!options.length) return closeSuggest();
    active = -1;
    suggest.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    input.removeAttribute('aria-activedescendant');
  }

  function highlight(i) {
    active = i;
    suggest.querySelectorAll('[role="option"]').forEach((li, j) => li.setAttribute('aria-selected', j === i));
    input.setAttribute('aria-activedescendant', `phl-opt-${i}`);
    suggest.querySelector(`#phl-opt-${i}`)?.scrollIntoView({ block: 'nearest' });
  }

  async function choose(o, source = 'recherche') {
    if (!map) return;
    closeSuggest();
    input.value = o.label;
    if (o.p) return select(o.p, true, source);
    try {
      const place = o.pp.toPlace();
      await place.fetchFields({ fields: ['location', 'viewport', 'addressComponents'] });
      token = null; // fin de session de saisie (facturation Google)
      // Statistique : ville et CP du lieu cherché, jamais la rue (une adresse peut être celle d'un domicile).
      const comp = (type) => place.addressComponents?.find((c) => c.types.includes(type))?.longText;
      track('recherche', null, { ville: comp('locality') ?? o.label, cp: comp('postal_code'), detail: source });
      villeUrl = o.label;
      setUrl('ville', villeUrl);
      goTo(place.location.toJSON(), false, place.viewport);
    } catch (e) {
      console.warn('[pharmacy-locator]', e);
      say(T.searchError);
    }
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 3) { lieux = []; lieuxFor = ''; }
    if (!q && origin) resetOrigin();
    renderSuggest();
    if (q.length >= 3) timer = setTimeout(() => loadLieux(q).then(renderSuggest), 200);
  });

  input.addEventListener('keydown', async (e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!options.length) return;
      e.preventDefault();
      const step = e.key === 'ArrowDown' ? 1 : -1;
      highlight(active < 0 ? (step > 0 ? 0 : options.length - 1) : (active + step + options.length) % options.length);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(timer);
      const q = input.value.trim();
      if (active < 0 && q.length >= 3 && q !== lieuxFor) { await loadLieux(q); renderSuggest(); }
      const o = options[Math.max(active, 0)];
      if (o) choose(o);
    } else if (e.key === 'Escape') {
      closeSuggest();
    }
  });

  input.addEventListener('focus', () => {
    placesLib ??= mapsP.then(() => google.maps.importLibrary('places'));
    if (input.value.trim()) renderSuggest();
  });
  input.addEventListener('blur', closeSuggest);
})();
